module.exports = "//static.jingzhuan.cn/soft-college/dist/prod/img/assets/images/middle_cover-f90750.png";